import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Chip,
  Tooltip,
  Button,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { useParams, Link } from "react-router-dom";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { statusEnum } from "utils/enum";
import getReportPath from "utils/getReportPath";

export default function ReportLocalListItem({ report }) {
  const params = useParams();
  const date = new Date(report.createdAt);
  const isMobile = useMediaQuery("(max-width:600px)");

  const estadoColor =
    report.state === statusEnum.APROBADO
      ? "success"
      : report.state === statusEnum.RECHAZADO
      ? "error"
      : report.state === statusEnum.PROCESO
      ? "warning"
      : "info";

  const estadoLabel =
    report.state === statusEnum.EN_ESPERA
      ? "EN ESPERA"
      : report.state === statusEnum.APROBADO
      ? "APROBADO"
      : report.state === statusEnum.RECHAZADO
      ? "RECHAZADO"
      : report.state === statusEnum.PROCESO
      ? "PROCESO"
      : "SIN ESTADO";

  return (
    <>
      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          backgroundColor: "background.paper",
          boxShadow: 1,
          transition: "0.2s",
          "&:hover": { boxShadow: 3, transform: "scale(1.01)" },
        }}
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Código del reporte */}
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">{report.code}</Typography>
            <Box display="flex" alignItems="center" gap={1} mt={0.5}>
              <FuseSvgIcon size={18} color="disabled">
                material-solid:list_alt
              </FuseSvgIcon>
              <Typography variant="caption" color="text.secondary">
                N° Reporte
              </Typography>
            </Box>
          </Grid>

          {/* Fecha */}
          <Grid item xs={6} sm={2}>
            <Typography>
              {`${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`}
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mt={0.5}>
              <FuseSvgIcon size={18} color="disabled">
                material-solid:calendar_today
              </FuseSvgIcon>
              <Typography variant="caption" color="text.secondary">
                Fecha
              </Typography>
            </Box>
          </Grid>

          {/* Formulario */}
          <Grid item xs={6} sm={2}>
            <Tooltip title={report.type_audit.value} arrow>
              <Typography noWrap fontWeight="medium">
                {report.type_audit.value}
              </Typography>
            </Tooltip>
            <Box display="flex" alignItems="center" gap={1} mt={0.5}>
              <FuseSvgIcon size={18} color="disabled">
                material-solid:list_alt
              </FuseSvgIcon>
              <Typography variant="caption" color="text.secondary">
                Formulario
              </Typography>
            </Box>
          </Grid>

          {/* Local */}
          <Grid item xs={12} sm={2}>
            <Tooltip title={report.local.fantasy_name} arrow>
              <Typography noWrap fontWeight="medium">
                {report.local.fantasy_name}
              </Typography>
            </Tooltip>
            <Box display="flex" alignItems="center" gap={1} mt={0.5}>
              <FuseSvgIcon size={18} color="disabled">
                material-solid:store
              </FuseSvgIcon>
              <Typography variant="caption" color="text.secondary">
                Local
              </Typography>
            </Box>
          </Grid>

          {/* Estado */}
          <Grid item xs={6} sm={2}>
            <Chip
              size="small"
              variant="outlined"
              color={estadoColor}
              label={estadoLabel}
            />
            <Typography variant="caption" color="text.secondary" mt={0.5}>
              Estado
            </Typography>
          </Grid>

          {/* Botón */}
          <Grid item xs={6} sm={2} textAlign={isMobile ? "left" : "right"}>
            <Button
              component={Link}
              to={`/supervisorLocals/${getReportPath(
                report.type_audit.value
              )}/${report.id}`}
              variant="contained"
              color="info"
              size="small"
            >
              Ver Auditoría
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ my: 1 }} />
    </>
  );
}
